import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';
import { ExportProfilesRequestPayload } from '../../models/export';
import {
  BatchOperationRequest,
  CampaignAddProfilesToFolderRequest,
  CampaignForProfileAddition,
} from '../../models/campaign/campaign';
import { map } from 'rxjs/operators';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root',
})
export class CampaignProfileService {
  constructor(private restService: RestService) {}

  addProfilesToCampaignFromSearch(
    queryParams: string,
    data: ExportProfilesRequestPayload,
  ): Observable<null> {
    return this.restService.CampaignProfile().addProfilesToCampaignFromSearch(queryParams, data);
  }

  addProfilesToFolder(data: CampaignAddProfilesToFolderRequest): Observable<null> {
    return this.restService.CampaignProfile().addProfilesToFolder(data);
  }

  addProfilesToCampaignFromFolder(data: BatchOperationRequest): Observable<null> {
    return this.restService.CampaignProfile().addProfilesToCampaignFromFolder(data);
  }

  getCampaigns(docId: string): Observable<CampaignForProfileAddition[]> {
    return this.restService
      .CampaignProfile()
      .getCampaigns(docId)
      .pipe(map((response) => RequestService.getData(response)));
  }
}
